export const DESCRIPTION = 'Official app - free';
export const CTA_BUTTON_TEXT = 'Get the app';
export const CTA_LINK_HOMEAWAY = 'https://t.hmwy.io/6WIuXZNLf6';
export const CTA_LINK_VRBO = 'https://t.vrbo.io/9t5qCBXLf6';
export const HOMEAWAY = 'HomeAway';
export const RATING = '436k Ratings';
export const STARS = 5;
export const TITLE = 'Get brand on the go!';
export const VRBO = 'Vrbo';
export const HOMEAWAY_SITE = 'homeaway_us';
